import { ArrowRight, Flame, LayoutTemplate, Magnet, MessageCircle, Presentation, Rocket } from "lucide-react";
import type { StarterTemplate } from "../types";
import { Modal } from "./Modal";

const iconMap = {
  funnel: LayoutTemplate,
  magnet: Magnet,
  webinar: Presentation,
  whatsapp: MessageCircle,
  saas: Rocket,
  journey: Flame,
};

interface TemplateGalleryProps {
  templates: readonly StarterTemplate[];
  onChoose: (template: StarterTemplate) => void;
  onClose: () => void;
}

export function TemplateGallery({ templates, onChoose, onClose }: TemplateGalleryProps) {
  return (
    <Modal
      description="Mulakan lebih pantas dengan blok yang boleh disunting sepenuhnya."
      onClose={onClose}
      title="Templat Permulaan"
      wide
    >
      <div className="template-grid">
        {templates.map((template) => {
          const Icon = iconMap[template.icon];
          return (
            <button className="template-card" key={template.id} onClick={() => onChoose(template)} type="button">
              <span className="template-card__visual" style={{ "--template-accent": template.accent } as React.CSSProperties}>
                <Icon size={24} />
                <i /><i /><i />
              </span>
              <span className="template-card__copy">
                <strong>{template.name}</strong>
                <small>{template.description}</small>
              </span>
              <ArrowRight className="template-card__arrow" size={18} />
            </button>
          );
        })}
      </div>
    </Modal>
  );
}

